<template>
  <span v-if="customer">
    <button type="button" @click="showModal" class="btn btn-sm btn-info">
      Danh sách
    </button>

    <b-modal
      size="xl"
      ref="my-modal"
      hide-footer
      title="Danh sách người nhận"
    >
      <div class="d-block text-center">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :search-options="{
            enabled: true,
            trigger: 'enter',
            skipDiacritics: true,
            searchFn: mySearchFn,
            placeholder: 'Tìm kiếm theo dữ liệu nhập vào'
          }"
          :pagination-options="{
            enabled: true,
            rowsPerPageLabel: 'các mục trong trang',
            nextLabel: 'tiếp',
            prevLabel: 'trước',
            mode: 'records',
            allLabel: 'Tất cả'
          }"
          :line-numbers="true"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Nút tạo đơn mới -->
            <span v-if="props.column.field === '_id'">
              <button
                class="btn btn-outline-primary btn-sm mx-2"
                @click="createNewOrder(props.row)"
              >
                <i class="bx bx-edit-alt"></i> Tạo đơn mới
              </button>
            </span>
      
            <!-- Cột ngày tạo nếu cần format thêm -->
            <span v-else-if="props.column.field === 'crt'">
              {{ formatDate(props.row.crt) }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </b-modal>
  </span>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";

let user = JSON.parse(localStorage.getItem("user"));

export default {
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      columns: [
        { label: "Mã đơn", field: "invoice", width: "140px" },
        { label: "Người gửi", field: "sender_fn" },
        { label: "Người nhận", field: "recipient_fn" },
        { label: "SĐT gửi", field: "sender_phone", width: "130px" },
        { label: "SĐT nhận", field: "recipient_phone", width: "130px" },
        { label: "Tạo đơn mới", field: "_id", width: "150px" },
      ],
      rows: [],
      isLoading: false,
    };
  },

  methods: {
    mySearchFn(row, col, cellValue, searchTerm) {
      const search = searchTerm.toUpperCase();
      const rgx = new RegExp(search, "igmu");
      const _value = cellValue?.toString() || "";
      return _value.match(rgx);
    },

    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    async showModal() {
      this.$refs["my-modal"].show();
      await this.fetchOrders();
    },

  async fetchOrders() {
    if (!this.customer) return;
    this.isLoading = true;

    try {
      const searchValue =
        this.customer.phone || this.customer.email || this.customer._id;

      const res = await axios.post(
        `${process.env.VUE_APP_SERVER_URL}/api/order/list`,
        {
          page: 1,
          limit: 50,
          search: searchValue,
          date: [],
        },
        { headers: { authorization: user?.token } }
      );

      // ✅ Lấy danh sách gốc
      const items = res.data?.items || [];

      // ✅ Lọc trùng lặp theo sender_phone + recipient_phone
      const unique = items.filter(
        (item, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              t.sender_phone === item.sender_phone &&
              t.recipient_phone === item.recipient_phone
          )
      );

      // Gán dữ liệu đã lọc
      this.rows = unique;
    } catch (err) {
      console.error("Lỗi khi tải danh sách người nhận:", err);
    } finally {
      this.isLoading = false;
    }
  },

    // ✅ Sửa hành động "Tạo đơn mới"
  createNewOrder(row) {
  // Trường hợp dữ liệu chứa order thật trong row.orders
    const invoice = row.invoice || (row.orders?.[0]?.invoice ?? null);

    if (!invoice) {
      this.$bvToast?.toast("Không tìm thấy mã đơn hàng để sao chép!", {
        title: "Lỗi",
        variant: "danger",
        solid: true,
      });
      return;
    }

    // Mở trang tạo đơn mới và copy từ ID đúng
    this.$router.push({
        path: "/tao-don-hang-moi",
          query: { copy: invoice },
        });
      }
  },
};
</script>
